export const ours = '86886875-fcb3-412d-8576-94194bb8cb28';
export const prod = '1459d56c-9a37-4963-aa10-7ee47a7614b6';
